import './expense.css';

import { useEffect, useState } from 'react';

import VerticalBar from '../../../components/verticalBar/verticalBar';
import SpacerBar from '../../../components/spacerBar/spacerBar';
import DropDownArrow from '../../../assets/icons/dropDownArrow/dropDownArrow';
import LoadingLogo from '../../../components/loadingLogo/loadingLogo';

export default function Expense({userCategories, expenses, filteredExpenses, localAddNewExpense}) {

    const [isLoading, setIsLoading] = useState(false);
    const [expenseCreated, setExpenseCreated] = useState(false);

    const unavalabileATM = (e) => {
        e.preventDefault();
        alert('feature not ready sorry');
    };

    const [formData, setFormData] = useState({
        expense_cat_id: userCategories && userCategories.length > 0 ? userCategories[0].expense_category_id : '',
        expense_amount: '',
        expense_date: '',
        expense_details: '',
        expense_image: '' 
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCategoryChange = (e) => {
        const selectedIndex = e.target.selectedIndex;
        const selectedOption = e.target.options[selectedIndex];
        const catId = selectedOption.getAttribute('data-cat-id');

        setFormData((prev) => ({
            ...prev,
            expense_cat_id: Number(catId)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        

        if(!formData.expense_amount || parseFloat(formData.expense_amount) === 0) {
            alert('Please enter an expense amount')
            return;
        }
        if (!formData.expense_date) {
            alert('Please select a date')
            return;
        }
        
        
        try {
            setIsLoading(true);
            const res = await fetch('/fastapi/api/add_expense', {
                method: 'POST',
                credentials: 'include', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expense_cat_id: Number(formData.expense_cat_id),
                    expense_amount: parseFloat(formData.expense_amount),
                    expense_date: formData.expense_date,
                    expense_details: formData.expense_details,
                    expense_image: formData.expense_image || "before image update"
                })
            },
        
        )
            setIsLoading(false);
            setExpenseCreated(true);
            if (!res.ok) {
                throw new Error('Failed to create expense');
            }

            const result = await res.json();
            console.log('Success:', result);
            alert('Expense created successfully!');
            window.location.reload();
            //localAddNewExpense(formData) -- local bug with reduce crashing 
           
        }
        catch (error) {
            console.error('Error submitting expense:', error);
            alert('Error adding expense. Please try again.');
        }

}

    if (isLoading) {
        return (
              <div className="no-access">
                <LoadingLogo/>
                <p style={{ color: 'red' }}>Laoding...</p>
              </div>
            )
    };

    if (expenseCreated) {
        return (
            <div className="no-access">
                      <LoadingLogo/>
                      <p style={{ color: 'red' }}>Expense Added</p>
                      {/* I want to change this to just clear the container and plop you on the page instead of reload in the browser */}
                      <a href="http://0.0.0.0:3001/expense" className="no-access-button">Add another expense</a>
                    </div>
        )
    }



    return(
        <div className="expense">
            <form className="expense-page" autoComplete='off'>
                <p>Add a New Expense:</p>
                <div className="expense-container">
                    <div className="expense-container-body">
                        <div className="expense-description">
                            <p>New Expense form:</p>
                            <p>{userCategories?.[0]?.expense_description}</p>
                        </div>
                        <VerticalBar height='100%'/>
                        <div className="expense-category">
                            <div className="expense-category-a">
                                <div className="expense-category-selector">
                                    <p>Category:</p>
                                    <div className="select-container">
                                        <select name="categories" id="categories" onChange={handleCategoryChange}>
                                            {userCategories?.map((cat, index) =>(
                                                <option key={index} value={cat?.expense_name} data-cat-id={cat?.expense_category_id}>{cat?.expense_name}</option>
                                            ))}
                                        </select>
                                        <DropDownArrow/>
                                    </div>
                                </div>
                                <SpacerBar width='90%' center="auto"/>
                            </div>
                            <div className="expense-category-b"> 
                                <input 
                                    className="input-amount"
                                    placeholder='Expense Amount'
                                    type="number"
                                    step="0.01"
                                    name="expense_amount"
                                    value={formData.expense_amount}
                                    onChange={handleChange}
                                    required
                                    />
                                <input 
                                    className="input-date" 
                                    placeholder='Date (YYYY-MM-DD)'
                                    type="date"
                                    name="expense_date"
                                    value={formData.expense_date}
                                    onChange={handleChange}
                                    required
                                    />
                            </div>
                            <div className="expense-category-c">
                                <SpacerBar width='90%' center="auto"/>
                                
                                    <textarea
                                        className="expense-notes" 
                                        placeholder='Expense notes:'
                                        name="expense_details"
                                        value={formData.expense_details}
                                        onChange={handleChange}
                                    ></textarea>
                               
                            </div>
                        </div>
                    </div>
                    <div className="expense-container-side">
                        {/*<div className="expense-image card">
                            <div><p>Image Capture:</p></div>
                            <div>
                                {/* Temporary placeholder 
                                <svg width="289" height="240" viewBox="0 0 289 240">
                                    <rect id="Rectangle_954" data-name="Rectangle 954" width="289" height="240" rx="19" fill="#88cdf6" opacity="0.2"/>
                                    <g id="Rectangle_952" data-name="Rectangle 952" fill="none" stroke="#72bf72" stroke-linecap="round" stroke-width="3" stroke-dasharray="20 8">
                                        <rect width="289" height="240" rx="19" stroke="none"/>
                                        <rect x="1.5" y="1.5" width="286" height="237" rx="17.5" fill="none"/>
                                    </g>
                                    <g id="Icon_akar-image" data-name="Icon akar-image" transform="translate(90.635 34.27)" opacity="0.8">
                                        <path id="Path_368" data-name="Path 368" d="M3,23.346A20.346,20.346,0,0,1,23.346,3H84.384A20.346,20.346,0,0,1,104.73,23.346V84.384A20.346,20.346,0,0,1,84.384,104.73H23.346A20.346,20.346,0,0,1,3,84.384Z" transform="translate(0 0)" fill="none" stroke="#39505d" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                                        <path id="Path_369" data-name="Path 369" d="M34.432,21.716A12.716,12.716,0,1,1,21.716,9,12.716,12.716,0,0,1,34.432,21.716Z" transform="translate(14.346 14.346)" fill="none" stroke="#39505d" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                                        <path id="Path_370" data-name="Path 370" d="M52.367,21.279,9,68.985H70.714A19.669,19.669,0,0,0,90.384,49.316v-.676c0-2.37-.89-3.281-2.492-5.036l-20.5-22.355a10.173,10.173,0,0,0-15.025.031Z" transform="translate(14.346 35.745)" fill="none" stroke="#39505d" stroke-linecap="round" stroke-linejoin="round" stroke-width="6"/>
                                    </g>
                                    <path id="Path_1480" data-name="Path 1480" d="M8.07-16.986c-1.235,0-3.929.122-5.659.215L2.424,0c1.628.089,4.1.207,5.162.207,5.958,0,9.894-3.933,9.894-9.266C17.479-14.153,13.932-16.986,8.07-16.986ZM8.181-2.739c-.633,0-1.656-.071-2.433-.137l-.01-11.042c.87-.054,1.915-.105,2.508-.105,3.692,0,5.788,1.808,5.788,5.31S11.96-2.739,8.181-2.739Zm19.852-9.3a4.745,4.745,0,0,0-4.5,3.2,14.6,14.6,0,0,0-.715-3.147,14.14,14.14,0,0,0-2.642.743,23.993,23.993,0,0,1,.383,4.287v3.141c0,2.139.037,3.458.064,3.857a14.473,14.473,0,0,0,3.1-.1c-.041-.5-.1-1.854-.1-3.753v0c.006-3.452,1.536-5.266,3.643-4.32a10.012,10.012,0,0,0,.756-3.9ZM39.855-.39a12.839,12.839,0,0,1-.55-4.2V-7.349c0-3.289-1.67-4.688-4.527-4.688a7.972,7.972,0,0,0-4.809,1.515A8.989,8.989,0,0,0,30.3-8.271a6.676,6.676,0,0,1,3.6-1.136,2.084,2.084,0,0,1,2.4,2.325v.333c-.311-.031-.738-.06-1.234-.06-3.753,0-5.894,1.584-5.894,4.02a2.976,2.976,0,0,0,3.225,3.1,4.482,4.482,0,0,0,4.027-2.482A7.359,7.359,0,0,0,37.264.248,6.643,6.643,0,0,0,39.855-.39ZM33.432-2.166a1.245,1.245,0,0,1-1.4-1.23c0-1.018,1.023-1.753,3.211-1.753a9.231,9.231,0,0,1,.942.047C35.806-3.076,34.562-2.166,33.432-2.166ZM50.7-2.1,47.68-2.673c-1.606-.308-1.935-.748-1.935-1.2a.693.693,0,0,1,.1-.349,7.6,7.6,0,0,0,1.263.1c2.807,0,5.275-1.445,5.275-4.047a3.527,3.527,0,0,0-.647-2.089l1.628.539a14.329,14.329,0,0,0,.306-2.048H49.5a6.717,6.717,0,0,0-1.955-.273c-2.8,0-5.284,1.524-5.284,4.136a3.441,3.441,0,0,0,2.028,3.192,2.265,2.265,0,0,0-.953,1.828A2.269,2.269,0,0,0,44.583-.864C43.012-.4,41.723.609,41.723,2.05c0,1.828,2.268,3.054,5.409,3.054,4.034,0,6.414-1.961,6.414-4.378,0-1.46-.848-2.437-2.847-2.82ZM47.416-9.941a1.94,1.94,0,0,1,2.142,1.816,2.114,2.114,0,0,1-2.326,1.909,1.943,1.943,0,0,1-2.148-1.813,2.121,2.121,0,0,1,2.332-1.913Zm.09,12.889c-1.774,0-2.943-.666-2.943-1.489,0-.72.921-1.338,2.09-1.659l2.381.457c1.193.23,1.512.558,1.512,1.039,0,.955-1.261,1.652-3.039,1.652ZM71.175-.39a12.839,12.839,0,0,1-.55-4.2V-7.349c0-3.289-1.67-4.688-4.527-4.688a7.972,7.972,0,0,0-4.809,1.515,8.989,8.989,0,0,0,.331,2.251,6.676,6.676,0,0,1,3.6-1.136,2.084,2.084,0,0,1,2.4,2.325v.333c-.311-.031-.738-.06-1.234-.06-3.753,0-5.894,1.584-5.894,4.02a2.976,2.976,0,0,0,3.225,3.1,4.482,4.482,0,0,0,4.027-2.482A7.359,7.359,0,0,0,68.584.248,6.643,6.643,0,0,0,71.175-.39ZM64.752-2.166a1.245,1.245,0,0,1-1.4-1.23c0-1.018,1.023-1.753,3.211-1.753A9.231,9.231,0,0,1,67.5-5.1C67.126-3.076,65.882-2.166,64.752-2.166ZM85.2-3.813V-7.642c0-2.838-1.426-4.4-3.785-4.4A4.322,4.322,0,0,0,77.19-9.118a14.535,14.535,0,0,0-.68-2.863,14.14,14.14,0,0,0-2.642.743,23.993,23.993,0,0,1,.383,4.287v3.141c0,2.139.037,3.458.064,3.857a14.473,14.473,0,0,0,3.1-.1c-.041-.5-.1-1.854-.1-3.753V-5.461c0-2.261,1.392-3.8,3-3.8,1.117,0,1.8.763,1.8,2.156v3.3c0,2.465.047,3.69.083,3.926a16.25,16.25,0,0,0,3.14-.237,26.839,26.839,0,0,1-.151-3.692ZM99.6-.39a12.839,12.839,0,0,1-.55-4.2h0V-18.337a21.024,21.024,0,0,0-3.072.867v5.485c-.336-.033-.685-.052-1.041-.052-4.426,0-7.233,2.838-7.233,6.822,0,3.188,1.8,5.522,4.518,5.522A4.12,4.12,0,0,0,96.141-2.3,7.522,7.522,0,0,0,97.009.247,6.643,6.643,0,0,0,99.6-.39ZM93.127-2.353c-1.394,0-2.282-1.34-2.282-3.181,0-2.386,1.431-3.94,3.66-3.94a5.1,5.1,0,0,1,1.473.223v3.125c0,2.243-1.349,3.773-2.851,3.773Zm21.216-14.633c-1.235,0-3.929.122-5.659.215L108.7,0c1.628.089,4.1.207,5.162.207,5.958,0,9.894-3.933,9.894-9.266C123.751-14.153,120.2-16.986,114.342-16.986Zm.111,14.247c-.633,0-1.656-.071-2.433-.137l-.01-11.042c.87-.054,1.915-.105,2.508-.105,3.692,0,5.788,1.808,5.788,5.31S118.232-2.739,114.453-2.739Zm19.852-9.3a4.745,4.745,0,0,0-4.5,3.2,14.6,14.6,0,0,0-.715-3.147,14.14,14.14,0,0,0-2.642.743,23.993,23.993,0,0,1,.383,4.287v3.141c0,2.139.037,3.458.064,3.857a14.473,14.473,0,0,0,3.1-.1c-.041-.5-.1-1.854-.1-3.753v0c.006-3.452,1.536-5.266,3.643-4.32a10.012,10.012,0,0,0,.756-3.9ZM140.724.307a6.3,6.3,0,0,0,6.245-6.558,5.434,5.434,0,0,0-5.551-5.786,6.294,6.294,0,0,0-6.236,6.554,5.435,5.435,0,0,0,5.543,5.79Zm.319-2.682c-1.645,0-2.76-1.413-2.754-3.462.006-1.978,1.052-3.517,2.781-3.517,1.627,0,2.8,1.378,2.791,3.462C143.855-3.9,142.769-2.376,141.043-2.376Zm15.468-9.664a4.122,4.122,0,0,0-3.93,2.639,14.466,14.466,0,0,0-.639-2.58,14.14,14.14,0,0,0-2.642.743,23.992,23.992,0,0,1,.383,4.287V.989c0,2.467.047,3.723.083,3.982a16.248,16.248,0,0,0,3.14-.237,28.274,28.274,0,0,1-.151-3.745V.252c.336.033.685.051,1.041.051,4.426,0,7.233-2.838,7.233-6.822,0-3.188-1.8-5.522-4.518-5.522Zm-2.283,9.724a5.1,5.1,0,0,1-1.473-.222V-5.607c0-2.243,1.349-3.773,2.851-3.773,1.394,0,2.282,1.34,2.282,3.181a3.541,3.541,0,0,1-3.66,3.883Z" transform="translate(61 199)" fill="#39505d" opacity="0.8"/>
                                </svg>


                            </div>
                            <div className="expense-img-buttons" >
                                <button className="button" onClick={(unavalabileATM)}>Choose Image</button>
                                <button className="button" onClick={unavalabileATM}>Take Image</button>
                            </div>
                        </div>*/}
                        <div className="expense-submit card temp-layout">
                            <div>
                                {/*<div className="complete-status">
                                    <p>Complete:</p>
                                    <p>00%</p>
                                </div>
                                <div className="progress-bar-container">
                                    <div className="progress-bar progress-bar-top"></div>
                                    <div className="progress-bar progress-bar-bottom"></div>
                                </div>*/}
                            </div>
                            <button className="button" onClick={handleSubmit}>submit</button>
                        </div>
                    </div>
                </div>
            </form> 
        </div>
    )
}